import React from "react";
import AppBar from "@mui/material/AppBar";
import Box from "@mui/material/Box";
import Toolbar from "@mui/material/Toolbar";
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";
import IconButton from "@mui/material/IconButton";
import MenuIcon from "@mui/icons-material/Menu";
import Menu from "@mui/icons-material/Menu";
import { Link, useNavigate } from "react-router-dom";
import axios from "axios";
import swal from "sweetalert";
import { MenuItem } from "@mui/material";
import { useState } from "react";
import Usermaster from "./user/Usermaster";
import Menubar from "./Menubar";
import "./Navbar.css";
import Grid from "@mui/material/Grid";
import logo from "./Geekay-logo.png";
import {
  createTheme,
  PaletteColorOptions,
  ThemeProvider,
} from "@mui/material/styles";
import { Stack } from "@mui/material";

function Navbar() {
  const navigate = useNavigate();
  const logoutSubmit = (e) => {
    e.preventDefault();

    const data = {
      "X-CSRF-TOKEN": document.head
        .querySelector('meta[name="csrf-token"]')
        ?.getAttribute("content"),
    };

    axios.post(`/api/logout`, data).then((res) => {
      if (res.data.status === 200) {
        localStorage.removeItem("auth_token");
        localStorage.removeItem("auth_name");
        swal("Success", res.data.message, "success");
        navigate("/certificates");
      }
    });
  };

  const { palette } = createTheme();
  const { augmentColor } = palette;
  const createColor = (mainColor) =>
    augmentColor({ color: { main: mainColor } });
  const theme = createTheme({
    palette: {
      anger: createColor("#F40B27"),
      apple: createColor("#A38A00"),
      steelBlue: createColor("#5C76B7"),
      violet: createColor("#BC00A3"),
    },
  });

  var fullname = localStorage.getItem("auth_name");
  var AuthButtons = "";
  if (!localStorage.getItem("auth_token")) {
    AuthButtons = (
      <div
        style={{
          display: "flex",
          alignItems: "center",
        }}
      >
        <ThemeProvider theme={theme}>
          <Button
            component={Link}
            sx={{ margin: 3, minWidth: 0, paddingRight: 3, paddingLeft: 3 }}
            to="/certificates/register"
            variant="contained"
            color="apple"
            fullWidth="true"
          >
            Register
          </Button>
          <Button
            component={Link}
            to="/certificates/login"
            color="apple"
            variant="contained"
            fullWidth="true"
          >
            Login
          </Button>
        </ThemeProvider>
      </div>
    );
  } else {
    AuthButtons = (
      <div
        style={{
          display: "flex",
          alignItems: "center",
        }}
      >
        <ThemeProvider theme={theme}>
          <Button
            onClick={logoutSubmit}
            sx={{ fontSize: 15 }}
            variant="contained"
            color="apple"
            fullWidth="true"
          >
            Logout
          </Button>
          <Typography
            marginLeft="30px"
            style={{ color: "#A38A00" }}
            variant="p"
          >
            Welcome, {fullname}
          </Typography>
        </ThemeProvider>
      </div>
    );
  }

  var Dashboard = "";
  if (localStorage.getItem("auth_token")) {
    Dashboard = (
      <Grid
        container
        direction="row"
        justifyContent="flex-start"
        alignItems="center"
        padding="8px"
        marginTop="3px"
        marginLeft="30px"
      >
        <Menubar />
      </Grid>
    );
  }

  return (
    <Box sx={{ flexGrow: 1 }}>
      <AppBar
        position="static"
        // disableScrollLock={true}
        style={{ background: "#FFFFFF" }}
      >
        <Toolbar>
          {/* <Typography variant="h4" component="div" sx={{ flexGrow: 1 }} >
            Certificate
          
          </Typography> */}
          {/* <div class="d-flex justify-content-between"> */}
          <Box sx={{ flexGrow: 1 }}>
            {/* <img alt='logo' src="http://geekaygroup.com/wp-content/uploads/2022/02/gklogo.png" /> */}
            <img src={logo} className="navlogo" alt="logo" />
          </Box>
          {Dashboard}
          {AuthButtons}
          {/* </div> */}
        </Toolbar>
      </AppBar>
    </Box>
  );
}

export default Navbar;
